export default {"src":"/_next/static/media/live_brackets_live_badge.b7c51b0e.svg","height":21,"width":46,"blurWidth":0,"blurHeight":0};